import { stopAnimation_for_guests, startAnimation_for_guests } from '../../../../epersonam/plugins/guestFormUtils';
import errorManager from '@/rollbar.js';

const setListener = (guestFormIdentifier, modalUsersOverLimit, guestValidation) => {
  $(guestFormIdentifier).on('click', function (ev) {
    ev.preventDefault();

    startAnimation_for_guests(guestFormIdentifier);

    /*
     * Checks overreaching of users created before form submission...
     * It'll send a notification if limit reached or if no limit has been set on parent BUs
     */
    let bu_id = $('#units_business_unit').val();
    if ($(guestFormIdentifier).data('control-no-limits')) {
      $('button.proceed').show();
      $.ajax({
        url: $(guestFormIdentifier).data('url-guests'),
        data: { bu_id: bu_id },
        success: function (data) {
          var displayAlert = data.displayAlert;
          var guests_limit = data.guests_limit;
          var guests_purchased = data.guests_purchased;
          var guests_actual_number = data.guests_actual_number;
          var limitReached = data.reached;
          const modalBody = $(modalUsersOverLimit).find('.modal-body .text');
          const verbMessage = guests_actual_number >= guests_limit ? 'Hai superato' : 'Stai superando';

          if (displayAlert && guests_limit == null) {
            $.getJSON($(guestFormIdentifier).data('url-no-limit'), { business_unit_id: bu_id, guests_actual_number: guests_actual_number });
            guestValidation.submit();
          } else if (displayAlert && limitReached) {
            $(modalUsersOverLimit).data('guests_limit', guests_limit);
            $(modalUsersOverLimit).data('guests_purchased', guests_purchased);
            $(modalUsersOverLimit).data('guests_actual_number', guests_actual_number);
            modalBody.text(
              $(modalUsersOverLimit)
                .find('.modal-body .text')
                .text()
                .replace('%{verb}', verbMessage)
                .replace('%{guests_limit}', guests_limit)
                .replace('%{guests_purchased}', guests_purchased),
            );
            if (guests_actual_number >= guests_limit) {
              $('button.proceed').hide();
            }
            $(modalUsersOverLimit).modal('show');
          } else {
            stopAnimation_for_guests(guestFormIdentifier);
            guestValidation.submit();
          }
        },
      }).fail(function () {
        stopAnimation_for_guests(guestFormIdentifier);
      });
    } else {
      guestValidation.submit();
    }
  });
};

// Bind click events on action_buttons inside the usersOverLimit modal
const bindModalUsersOverLimitEvents = (guestFormIdentifier, modalUsersOverLimit, guestValidation) => {
  console.log('binding modal events...');
  $(modalUsersOverLimit)
    .on('shown.bs.modal', function (e) {
      // Bootstrap does not handle properly multiple modals on the same page...
      // Remove additional modal-backdrop overlays that were created opening up other modals
      if ($('.modal-backdrop').length > 1) {
        $('.modal-backdrop').not(':last').remove();
      }

      const $this_modal = $(this);

      var guests_purchased = $this_modal.data('guests_purchased');
      var guests_limit = $this_modal.data('guests_limit');
      var guests_actual_number = $this_modal.data('guests_actual_number');

      // set the limit_count on modal description
      var text_with_count = $this_modal.find('.modal-body .text').text().replace('%{guests_limit}', guests_limit);
      $this_modal.find('.modal-body .text').text(text_with_count);

      // cancel the current submit
      $this_modal.find('button.ignore').on('click', function (ev) {
        $this_modal.modal('hide');

        stopAnimation_for_guests(guestFormIdentifier);

        return false;
      });

      // proceed with form submission
      $this_modal.find('button.proceed').on('click', function (ev) {
        $this_modal.modal('hide');

        stopAnimation_for_guests(guestFormIdentifier);

        $.getJSON($(guestFormIdentifier).data('url-worker'), {
          business_unit_id: $('#units_business_unit').val(),
          guests_purchased: guests_purchased,
          guests_limit: guests_limit,
          guests_actual_number: guests_actual_number,
        });
        guestValidation.submit();

        return true;
      });
    })
    .on('hide.bs.modal', function (e) {
      $(this).find('button.proceed').unbind();
      $(this).find('button.ignore').unbind();
    });
};

const init = (guestFormIdentifier, modalUsersOverLimit, guestValidation) => {
  try {
    bindModalUsersOverLimitEvents(guestFormIdentifier, modalUsersOverLimit, guestValidation);
    setListener(guestFormIdentifier, modalUsersOverLimit, guestValidation);
  } catch (e) {
    errorManager(e);
  }
};

window.GuestFormSubmit = {
  init: init,
};
